import {showNotify} from "vant";
import {log} from "@/components/utils/HComFunctions.js";

class HRouter {
    static instance;
    routeParams = {};

    constructor() {
        if (HRouter.instance) {
            return HRouter.instance;
        }
        HRouter.instance = this;
    }

    go = (routeName, params = null) => {

        routeName = routeName.replace('/', '')
        routeName = routeName.replace('moregame_', '')

        window.scrollTo({
            top: -10,
        });
        this.routeParams[routeName] = params;
        window.globalRouter.push({name: routeName}).then(r => {
        });
    }

    goOff = (routeName, params = null) => {
        window.scrollTo({
            top: -10,
        });
        this.routeParams[routeName] = params;
        if (routeName.indexOf('/') !== -1) {
            showNotify({message: "路由名称错误，不要有'/'符号"});
        }
        window.globalRouter.replace({name: routeName, params: {}, query: {}}).then(r => {
        });
    }

    goBack = () => {
        window.scrollTo({
            top: -10,
        });
        let targetRouteName = window.globalRouter.currentRoute.value.name;
        if (targetRouteName && (targetRouteName in this.routeParams)) {
            delete this.routeParams[targetRouteName];
        }
        window.globalRouter.back();
    }

    //使用的时候最好 ?. 一下，防止出现错误日志提醒
    getRouteParams = () => {
        let targetRouteName = window.globalRouter.currentRoute.value.name;
        if (targetRouteName && (targetRouteName in this.routeParams)) {
            return this.routeParams[targetRouteName];
        } else {
            this.goBack();
            // this.goOff("home");
            log("\n\n获取页面参数错误\n\n\n");
        }
    }
}

export const hr = new HRouter();
